import { render, staticRenderFns } from "./IosBookTaskManage.vue?vue&type=template&id=f4a5a628&scoped=true"
import script from "./IosBookTaskManage.vue?vue&type=script&lang=js"
export * from "./IosBookTaskManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4a5a628",
  null
  
)

export default component.exports